import { ReactNode } from "react";
import { TicketType } from "../components/TicketsPanel/Ticket";
import { CustomNotifyType } from "../components/Modal/ModalNotify/Custom/CustomNotifyRouter";

export enum BonusType {
    Balance = 1,
    RegularTicket = 2,
    RareTicket = 3,
    EpicTicket = 4,
    LegendaryTicket = 5,
    Fragment = 6,
}

export enum BonusReason {
    Welcome = 1,
    CollectionComplete = 2,
    Compensation = 3,
    Regular = 4,
}

export interface ITicketsBalances {
    regularTickets: number,
    rareTickets: number,
    epicTickets: number,
    legendaryTickets: number;
}

export interface IUserBalances extends ITicketsBalances {
    balance: number;    
}

export enum NotifyType {
    Custom = 1,
    DrawResult = 2,
    CollectionComplete = 3,
    FragmentReward = 4,
    //NotAllowWrite = 5,
    Bahavior = 6,
    ChallengeReward = 7,
}

export interface INotify {
    id: number;
    type: NotifyType;
    title: string;
    message: string;
    customType?: CustomNotifyType;
    isMarkdown: boolean;
}

export interface ITicketsError {
    amount: number;
    ticketType: TicketType;
}

export interface IBonusItem {
    type: BonusType,
    value: number;
}

export interface IUserBonus {
    reason: BonusReason,
    bonuses: IBonusItem[];
}

export interface IUserInfo {
    id: number;
    recordId: number;
    exp: number;
    level: number;

    balance: number;
    tickets: ITicketsBalances;
    balanceError: ReactNode | null;
    ticketsBalanceError: ITicketsError | null;

    profit: number;
    realTimeProfitState: boolean;
    makedProfit: number;
    lastProfitMaking: number;    

    yclid: string | null;
    isFirstLaunch: boolean | undefined;
    bonuses: IUserBonus[];

    allowWrite: boolean | undefined;
}